import axios from '../../plugins/TradutorInterceptor'

export const state = {
    filtros: null,
}

export const mutations = {
    SET_FILTROS(state, filtros) {
        state.filtros = filtros;
    },
}

export const getters = {
    getFiltros(state) {
        return state.filtros;
    },
}

export const actions = {
    listarGruposTarifarios(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('grupos-tarifarios' + payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    exibirGrupoTarifario(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('grupos-tarifarios/' + payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    criarGrupoTarifario(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('grupos-tarifarios', payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    atualizarGrupoTarifario(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('grupos-tarifarios/' + payload.id, payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    excluirGrupoTarifario(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete('grupos-tarifarios/' + payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/gruposTarifarios.js